import {
  useAppDispatch,
  useAppSelector,
} from "../../../../services/hooks/useReduxHooks";
import { setLoyaltyTermsAndConditionsDrawer } from "../../../../services/redux/slices/globalComponentsToggleSlice";
import { localizedNumber } from "../../../../utils/help/localization/localization";
import { MileStone } from "../../Icons/loyalty.icons";
import styles from "./NavigationBar.module.scss";

export const NavigationBar = () => {
  const loyaltyState = useAppSelector((state) => state.cartAndLoyaltyReducer);
  const dispatch = useAppDispatch();
  const pointingSystem = loyaltyState.pointingSystem;
  const currentMileStones = pointingSystem?.restaurantPackageOffers;
  const selectedMilestoneIndex = useAppSelector(
    (state) =>
      state.globalComponentsToggleSlice.loyaltyTermsAndConditionsDrawer
        .selectedMilestone
  );
  const currentMilestoneId =
    currentMileStones &&
    currentMileStones[selectedMilestoneIndex].pointingMilestone?.id;

  return (
    <div className={styles.container}>
      <div
        className={`${styles.container__tabs} ${styles.container__tabs__spaced}`}
      >
        {currentMileStones &&
          currentMileStones.map((milestone, index) => {
            return (
              <button
                id={`${milestone.id}`}
                key={index}
                data-testid={milestone.pointingMilestone?.points + "_tab"}
                onClick={() =>
                  dispatch(
                    setLoyaltyTermsAndConditionsDrawer({
                      isOpen: true,
                      selectedMilestone: index,
                    })
                  )
                }
                className={`${styles.tab_btn} ${
                  currentMilestoneId === milestone.pointingMilestone?.id
                    ? styles.tab_btn_active
                    : ""
                }`}
              >
                {localizedNumber(milestone.pointingMilestone?.points)}{" "}
                <MileStone />
              </button>
            );
          })}
      </div>
    </div>
  );
};
